// src/pages/AgenticWorkflow/components/DropdownMenu/DropdownMenu.tsx
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { deleteAgenticWorkflow } from 'services/api/WorkflowServiceAPI';
import type { Workflow } from '../../AgenticWorkflow.types';
import styles from './DropdownMenu.module.scss';
import { Dropdown } from 'common/components/Dropdown';

export interface DropdownMenuProps {
    workflow: Workflow;
    onDeleteSuccess?: () => void;
    onUploadClick?: (workflow: Workflow) => void;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ workflow, onDeleteSuccess, onUploadClick }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const navigate = useNavigate();

    const toggleDropdown = (e: React.MouseEvent): void => {
        e.stopPropagation();
        setIsOpen((prevOpen) => !prevOpen);
    };

    const handleEdit = (e: React.MouseEvent): void => {
        e.stopPropagation();
        navigate(`/agentic-workflow-builder/edit/${workflow.id}`, {
            state: { workflow },
        });
        setIsOpen(false);
    };

    const handleUpload = (e: React.MouseEvent): void => {
        e.stopPropagation();
        if (onUploadClick) {
            onUploadClick(workflow);
        }
        setIsOpen(false);
    };

    const handleDelete = async (e: React.MouseEvent): Promise<void> => {
        e.stopPropagation();
        const confirmed = window.confirm('Are you sure you want to delete this workflow?');
        if (!confirmed) return;

        try {
            await deleteAgenticWorkflow(workflow.id);
            if (onDeleteSuccess) {
                onDeleteSuccess();
            }
        } catch (error) {
            console.error('Error deleting workflow:', error);
            alert('Failed to delete workflow.');
        } finally {
            setIsOpen(false);
        }
    };

    return (
        <div className={styles.dropdown}>
            <button ref={buttonRef} className={styles.toggleButton} onClick={toggleDropdown} type='button'>
                Actions
            </button>

            <Dropdown isOpen={isOpen} onClose={() => setIsOpen(false)} toggleRef={buttonRef}>
                <div className={styles.menuItem} onClick={handleEdit}>
                    Edit
                </div>
                <div className={styles.menuItem} onClick={handleUpload}>
                    Upload Leads
                </div>
                <div className={`${styles.menuItem} ${styles.danger}`} onClick={handleDelete}>
                    Delete
                </div>
            </Dropdown>
        </div>
    );
};

export default DropdownMenu;
